
//40
Object.defineProperty(exports, "__esModule", { value: true });
require("./Pagination.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "PaginationTest733151333",
    {"button-common-mixin":"PaginationTest733151333--button-common-mixin","root":"PaginationTest733151333--root","disabled":"Pagination1375807887--disabled","materialBlueGray100":"#CFD8DC","materialBlueGray200":"#B0BEC5","materialBlueGray700":"#455A64","materialRed500":"#f44336"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/pagination/PaginationTest.st.css
// module id = 1287
// module chunks = 0